// extracted by mini-css-extract-plugin
export default {"PageScaffold":"PageScaffold_PageScaffold__tUhJZ","Card":"PageScaffold_Card__d6qmt"};